import { CommonModule } from '@angular/common';
import {
    ChangeDetectionStrategy,
    Component,
    EventEmitter,
    input,
    Input,
    OnChanges,
    OnInit,
    Output,
    SimpleChanges,
} from '@angular/core';
import { EventTrackerService } from '@core/services/event-tracker.service';
import { ANALYTICS_EVENTS } from '@core/utils/AnalyticsEvents';
import { LinkComponent } from '@shared/link/link.component';
import { QuicklinkModule } from 'ngx-quicklink';

@Component({
    selector: 'app-cta-button',
    templateUrl: './cta-button.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [CommonModule, LinkComponent, QuicklinkModule],
})
/*
    This CTA button renders a button or a link depending on the type input.
    if styleOverride is true, it will not apply any default styles to the button.
    the variant input decides what the default styles will be for the button
*/
export class CtaButtonComponent implements OnInit, OnChanges {
    @Input() type: 'button' | 'link' = 'link';
    @Input() link: string[] = [];
    @Input() additionalClasses: string[] = [];
    @Input() variant: 'primary' | 'secondary' | 'secondary-teal' = 'primary';
    @Input() styleOverride: boolean = false;
    @Output() onClick = new EventEmitter<Event>();

    disabled = input<boolean>(false);

    constructor(private eventTrackerService: EventTrackerService) {}

    ngOnInit(): void {}

    clickHandler(event: Event, propagateToOutput: boolean = true) {
        if (propagateToOutput) {
            this.onClick.emit(event);
        }
        const target = event.target as HTMLElement;
        this.eventTrackerService.trackEvent(
            ANALYTICS_EVENTS.CTA_BUTTON_CLICKED,
            {
                text: target.innerText,
            }
        );
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (!this.styleOverride) {
            if (this.variant === 'primary') {
                this.additionalClasses.push(
                    'rounded-xl border border-red bg-red text-white hover:bg-red-400 hover:text-white; w-fit py-3'
                );
            } else if (this.variant === 'secondary') {
                this.additionalClasses.push(
                    'rounded-xl border border-lightgrey bg-white text-darkgrey hover:border-darkgrey w-fit py-3'
                );
            } else if (this.variant === 'secondary-teal') {
                this.additionalClasses.push(
                    'rounded-xl border border-teal bg-secondary-teal text-white hover:bg-secondary-teal-hover w-fit py-3'
                );
            }
        }

        if (changes.link && changes.link.currentValue.length) {
            const routerLink = changes.link.currentValue;
        }
    }
}
